import { render, staticRenderFns } from "./Law.vue?vue&type=template&id=165288d6&scoped=true&"
import script from "./Law.vue?vue&type=script&lang=js&"
export * from "./Law.vue?vue&type=script&lang=js&"
import style0 from "./Law.vue?vue&type=style&index=0&id=165288d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165288d6",
  null
  
)

export default component.exports